import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { FileText } from 'lucide-react';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="min-h-screen bg-sauna-beige py-12 px-4">
      <Helmet>
        <title>Terms and Conditions - SaunaDip</title>
      </Helmet>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-sauna-navy flex items-center justify-center gap-2">
            <FileText className="h-8 w-8 text-sauna-orange" />
            Terms and Conditions
          </h1>
          <div className="h-1 w-32 divider-gradient rounded-full mx-auto mt-4"></div>
        </div>
        <Card className="border-none shadow-lg">
          <CardContent className="p-8">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">Table of Contents</h2>
              <ul className="list-disc list-inside space-y-1 text-sauna-navy/80">
                <li><a href="#introduction" className="text-sauna-orange hover:underline">1. Introduction</a></li>
                <li><a href="#acceptance" className="text-sauna-orange hover:underline">2. Acceptance of Terms</a></li>
                <li><a href="#use-of-service" className="text-sauna-orange hover:underline">3. Use of Our Service</a></li>
                <li><a href="#user-content" className="text-sauna-orange hover:underline">4. User Content</a></li>
                <li><a href="#intellectual-property" className="text-sauna-orange hover:underline">5. Intellectual Property</a></li>
                <li><a href="#disclaimer" className="text-sauna-orange hover:underline">6. Disclaimer of Warranties</a></li>
                <li><a href="#limitation-of-liability" className="text-sauna-orange hover:underline">7. Limitation of Liability</a></li>
                <li><a href="#governing-law" className="text-sauna-orange hover:underline">8. Governing Law</a></li>
                <li><a href="#changes" className="text-sauna-orange hover:underline">9. Changes to Terms</a></li>
                <li><a href="#contact" className="text-sauna-orange hover:underline">10. Contact Us</a></li>
              </ul>
            </div>

            <section id="introduction" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">1. Introduction</h2>
              <p className="text-sauna-navy/90">Welcome to SaunaDip. These Terms and Conditions govern your use of our website and services. By accessing or using our Service, you agree to be bound by these Terms.</p>
            </section>

            <section id="acceptance" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">2. Acceptance of Terms</h2>
              <p className="text-sauna-navy/90">By using our Service, you confirm that you accept these Terms and that you agree to comply with them. If you do not agree to these Terms, you must not use our Service.</p>
            </section>

            <section id="use-of-service" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">3. Use of Our Service</h2>
              <p className="text-sauna-navy/90">You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to use the Service in any way that could damage, disable, overburden, or impair the Service or interfere with any other party's use of the Service.</p>
            </section>

            <section id="user-content" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">4. User Content</h2>
              <p className="text-sauna-navy/90">If the Service allows you to post content, you are solely responsible for the content that you post, upload, link to or otherwise make available via the Service. You agree that we are not responsible for any content that you post or make available on the Service.</p>
            </section>

            <section id="intellectual-property" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">5. Intellectual Property</h2>
              <p className="text-sauna-navy/90">The Service and its original content, features, and functionality are and will remain the exclusive property of SaunaDip and its licensors.</p>
            </section>

            <section id="disclaimer" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">6. Disclaimer of Warranties</h2>
              <p className="text-sauna-navy/90">The Service is provided on an "AS IS" and "AS AVAILABLE" basis. SaunaDip makes no representations or warranties of any kind, express or implied, as to the operation of their Service or the information, content, or materials included thereon.</p>
            </section>

            <section id="limitation-of-liability" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">7. Limitation of Liability</h2>
              <p className="text-sauna-navy/90">In no event shall SaunaDip, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.</p>
            </section>

            <section id="governing-law" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">8. Governing Law</h2>
              <p className="text-sauna-navy/90">These Terms shall be governed and construed in accordance with the laws of Ireland, without regard to its conflict of law provisions.</p>
            </section>

            <section id="changes" className="mb-12">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">9. Changes to Terms</h2>
              <p className="text-sauna-navy/90">We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms.</p>
            </section>

            <section id="contact" className="mb-4">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">10. Contact Us</h2>
              <p className="text-sauna-navy/90">If you have any questions about these Terms, please contact us at Thomcor House, Mungret Street, Limerick, Co. Limerick.</p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsAndConditions; 